import { Modal } from "react-bootstrap";
import { ExclamationTriangle } from "react-bootstrap-icons";
import { HeaderText } from "./Controls/HeaderText";
import { Button } from "./Controls/Button";
import { useNavigate } from "react-router-dom";

export interface NoMoreSpacesModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  planId: number;
}

export function NoMoreSpacesModal({ show, setShow, planId }: NoMoreSpacesModalProps) {
  const navigate = useNavigate();

  function handleModifyPlan() {
    setShow(false);
    navigate(`/user/plan/${planId}/edit`); 
  }

  return (
    <Modal centered show={show} onEscapeKeyDown={() => setShow(false)}>
      <Modal.Header>
        <HeaderText>No More Spaces Left</HeaderText>
      </Modal.Header>

      <Modal.Body>
        <div
          className="text-secondary gap-4 px-2 mb-4"
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            alignItems: "center",
          }}
        >
          <ExclamationTriangle size="32" className="text-warning" />
          <span>
            You need more spaces to add this parker. Do you want to add more?
          </span>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex">
        <Button
          className="flex-grow-1"
          onClick={() => setShow(false)}
        >
          No
        </Button>
        <Button
          className="flex-grow-1 btn-main"
          onClick={handleModifyPlan}
        >
          Yes, modify plan now
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
